import { EventEmitter, Injectable } from "@angular/core";
import { CodeStatusSummary, DeploymentSummary } from "../models/configuration/selfServe/codeManagementObjects";

@Injectable({
    providedIn: 'root'
})
export class EventService {
    public SSCMListStatusChangedEvent = new EventEmitter();
    public SSCMDeploymentCompletedEvent = new EventEmitter();
    public ConcurrentAuth = new EventEmitter<boolean>();
    public SaveButtonStateEvent = new EventEmitter<boolean>();

    public SSCMListStatusChanged(summary: CodeStatusSummary) {
        this.SSCMListStatusChangedEvent.emit(summary);
    }

    public SSCMDeploymentCompleted(summary: DeploymentSummary){
        this.SSCMDeploymentCompletedEvent.emit(summary);
    }

    public setConcurrentAuthStatus(status: boolean) {
        this.ConcurrentAuth.emit(status);
    }

    public SaveButtonState(isEnabled: boolean){
        this.SaveButtonStateEvent.emit(isEnabled);
    }
}